import React from 'react';
import { getParameterByName } from 'utils/utils';
import { withPageStaticProps } from 'utils/header';
import auth from 'utils/auth';
import { trackCxLogin } from 'utils/metrics';
import accountsApi from 'services/accountsApi';
import Loading from 'components/Loading';

interface Props {
  [key: string]: any;
}

interface State {
  loading: boolean;
  error?: string;
}

class Login extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      error: undefined,
    };
  }

  componentDidMount() {
    const email = getParameterByName('customer_email');
    const token = getParameterByName('cs_token');

    accountsApi.customerServiceLogin(email!, token!).then(
      (res) => {
        auth.storeUserJson(res);
        trackCxLogin({
          cxEmail: getParameterByName('cx_email'),
        });
        window.location.href = `${process.env.NEXT_PUBLIC_APP_URL}/account/events`;
      },
      (err) => {
        console.log(err);
        this.setState({ loading: false, error: err.responseText });
      },
    );
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    if (this.state.error) {
      return <div>{this.state.error}</div>;
    }
  }
}

export const getStaticProps = withPageStaticProps();

export default Login;
